module.exports = __webpack_public_path__ + "static/jake.35bb93de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/jake.jpg
// module id = 463
// module chunks = 261706647590803